import React from 'react';
import {
    Link, LinkingIOS
} from 'react-router-dom';
import RegisterClasses from './RegisterClasses';
import DatePickerDropdown from './DatePickerDropdown';
import moment from 'moment';
import '../App.css';
import config from '.././config';
import $ from 'jquery';
import {
    Form, Input, Select, Checkbox,
    Steps, DatePicker, Modal, Table, Icon, Menu, Alert, Radio, Row, Col, Spin, Card
} from 'antd';
import usStates from '../usStates';
import Admin from '../Admin/Admin';


const convertClassModeIDtoName = (id) => {
    return id === 1 ? 'Online' : (id === 2 ? 'In Person' : 'Hybrid');
}

const Step = Steps.Step;
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;
//Form Layouts
const columnsExtClass = [{
    title: 'Class',
    dataIndex: 'Name',
    key: 'Name',
}
];

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};

const shortFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 4 },
        sm: { span: 3 },
    },
};

const midFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 6,
        },
    },
};

class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state.student = {
            Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
            StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned', SComments: ''
        };
        this.state.employer = {
            Id: -1, CompanyName: '', Address: '', State: '',
            City: '', ZipCode: '', PhoneNumber: '', Email: ''
        };
        this.state.optionList.push(<Option value="All">All</Option>)
        this.state.optionList.push(<Option value="TCP">TCP</Option>)
        this.state.optionList.push(<Option value="ESCC">ESCC</Option>)
        this.state.optionList.push(<Option value="External Civil Rights Training">External Civil Rights Training</Option>)
        this.register = { student: this.state.student, employer: this.state.employer };
        this.DobUser = '';
        this.employerList = [];
        this.employerDisplayList = [];
        this.companydropdown = '';
        this.userButtton = "Already Registered before!";

        // State dropdown
        this.stateList = usStates.listofUSstates();
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {

                this.employerList = data;
                //adding N/A employer to top of list
                //this.employerDisplayList.push(<Option key={344}>{"Employer Not Selected"}</Option>);

                for (let i = 0; i < data.length; i++) {
                    if (data[i].Id != 344) {  //dont add repeating 344 ID employer not found
                        var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                        //this is populating the dropdown for employers
                        this.employerDisplayList.push(
                            <Option key={data[i].Id}>{optDis}</Option>
                        );
                    }
                }
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

    }
    //function to get system name from url
    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    // State variables
    state = ({
        emailValue: "Both",
        current: 0,
        filterSystem: "None",
        currentMenu: "Yes",
        userVisible: false,
        classData: [],
        filledMenuDisplay: false,
        confirmDirty: '',
        classDataKeys: [],
        inputControl: true,
        searchClassData: '',
        emailValidatorUser: '',
        emailValidatorInfo: '',
        emailValidatorEmployer: '',
        loading: false,
        visibleWarning: false,
        tableWarning: [],
        selectedRowKeys: [],
        selectedRows: [],
        existingButton: "Start New Registration",
        hideTextbox: true,
        isUserNew: true,
        employerNotList: false,
        initialModal: true,
        initialClass: "All",
        optionList: []

    });



    columnsSelect = () => {
        return ([{
            title: 'Class',
            dataIndex: 'Name',
            key: 'Name',
        }, {
            title: 'Category',
            dataIndex: 'CategoryName',
            key: 'CategoryName',
        }, {
            title: 'Class Mode',
            dataIndex: 'ClassModeID',
            key: 'ClassModeID',
            render: (text, record, index) => {
                return (
                    convertClassModeIDtoName(text)
                )
            }
        }, {
            title: 'Attendance Selection',
            dataIndex: 'ClassModeAttendenceID',
            key: 'ClassModeAttendenceID',
            render: (text, record, index) => {
                // if hybrid course, select attendance
                if (record.ClassModeID === 3) {
                    // if on the first page, give options
                    if (this.state.current === 0) {
                        const disableOnline = record.OnlineCapacity === 'Capacity Full';
                        const disableInPerson = record.Capacity === 'Capacity Full';

                        return (
                            <Select
                                title="Selection for {class}"
                                placeholder="Attendance Selection"
                                onChange={(optID) => { this.handleSelectClassModeChoice(optID, record) }}
                                style={{ width: 120 }}>
                                <Option disabled={disableOnline} value="Online">Online</Option>
                                <Option disabled={disableInPerson} value="In Person">In Person</Option>
                            </Select>
                        )
                    }
                    // on any other page (page 4), only display what's selected
                    else {
                        // !!! currently if they don't select on first page this won't show anything !!!
                        return record.ChosenAttendance
                    }

                } else {
                    return (
                        convertClassModeIDtoName(record.ClassModeID)
                    )
                }
            }
        }, {
            title: 'Starts',
            dataIndex: 'StartDate',
            key: 'StartDate',
            render: (text, record, index) => {
                if (record.SystemName == "ESCC") {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );

                }
                else {
                    if (record.IsIndefinite == "Indefinite") {
                        return (
                            <span>
                                This class is open indefinitely.
                            </span>
                        )
                    }
                    return (
                        <span>
                            {moment(text).format('l [at] h:mm A z')}
                        </span>
                    );
                }
            }
        }, {
            title: 'Ends',
            dataIndex: 'EndDate',
            key: 'EndDate',
            render: (text, record, index) => {
                if (record.IsIndefinite == "Indefinite") {
                    return (
                        <span>
                            N/A
                        </span>
                    )
                }
                return (
                    <span>
                        {moment(text).format('l')}
                    </span>
                );
            }
        },
        {
            title: 'Cost',
            dataIndex: 'Cost',
            key: 'Cost',
        },
        {
            title: 'Venue',
            dataIndex: 'Venue',
            key: 'Venue',
            render: (text, record, index) => {
                var url = record.VenueURL;
                if (url === '') {
                    return (
                        <span>
                            {text}
                        </span>
                    );
                }

                else {
                    if (!/^(?:f|ht)tps?\:\/\//.test(record.VenueURL)) {
                        console.log("here");
                        url = 'http://' + record.VenueURL;
                    }
                    return (
                        <span>
                            <a target="_blank" href={url}> {text}</a>
                        </span>
                    );

                }


            }
        },
        {
            title: 'Address',
            dataIndex: 'Address',
            key: 'Address',
        },
        {
            title: 'Seats Available',
            dataIndex: 'Capacity',
            key: 'Capacity',
            render: (text, record, index) => {
                if (record.IsIndefinite == "Indefinite") {
                    return (
                        <span>
                            N/A
                        </span>
                    )
                }
                // online capacity is N/A for all non-hybrid courses
                if (record.OnlineCapacity === 'N/A') {
                    return (<span>{text}</span>);
                } else {
                    return (<span>In Person: {record.Capacity} <br /> Online: {record.OnlineCapacity}</span>)
                }
            }
        },
        {
            title: 'Comments',
            dataIndex: 'Comments',
            render: (text, record, index) => {
                if (record.Comments) {
                    return (
                        <div className="editable-row-operations">
                            <span>
                                <a onClick={() => Modal.info({
                                    title: record.Comments, onOk() { },
                                })}>More Info</a>
                            </span>
                        </div>
                    );
                }
            }
        }
        ])
    }

    /**
     * This function sets the chosenAttendance for record in classData to reflect selection 
     * for the hybrid course (newClassMode is selection)
     * @param {var} newClassMode
     */
    handleSelectClassModeChoice = (newClassMode, record) => {
        // thanks stack overflow: https://stackoverflow.com/questions/29537299/react-how-to-update-state-item1-in-state-using-setstate
        // make a copy of state to eventually mutate
        let classDataCopy = [...this.state.classData];
        // copy the item
        let hybridClass;
        // iterate over class data to find the class we want to change
        this.state.classData.some((item) => {
            // some will stop when return true
            if (item.Id === record.Id) {
                hybridClass = item;
                return true;
            } else {
                return false;
            }
        });
        // update the item
        hybridClass.ChosenAttendance = newClassMode;
        // update the array. Note that yes it's a mutation but not directly on state bc this is a copy
        classDataCopy.some((item) => {
            // iterate until proper class found and then updated
            if (item.Id === hybridClass.Id) {
                item = hybridClass;
                return true;
            } else {
                return false;
            }
        });
        // now we can set state to the updated information
        this.setState({ classData: classDataCopy });
    }

    /**
    *  Renders the transition and steps
    */
    render() {
        const steps = [{
            title: 'Select Classes',
        },
        {
            title: 'Your Info',
        },
        {
            title: 'Employer Info',
        },
        {
            title: 'Verification',
        }
        ];
        //Columns for selected table

        let page = null;
        if (this.state.current === 0) {
            page = this.firstPage();
        }
        else if (this.state.current === 1) {
            page = this.secondPage();
        }
        else if (this.state.current === 2) {
            page = this.thirdPage();
        }
        else if (this.state.current === 3) {
            if (Admin.isAdminLoggedIn()) {
                page = this.adminFourth();
            } else {
                page = this.fourthPage();
            }
        }
        const { current } = this.state;
        return (
            <div className="color3">
                <div style={{ color: 'red', fontSize: '1.5em', textAlign: 'center', paddingBottom: '5%' }}>
                    Please only register for classes using Microsoft Edge or Google Chrome.
                </div>
                <Steps current={current}>
                    {steps.map(item =>
                        <Step key={item.title} title={item.title} />
                    )}
                </Steps>
                <div>
                    <Form style={{ marginTop: 20 }}>
                        {page}
                    </Form>
                </div>
                <div className="steps-action">
                    {/*Renders Previous*/}
                    {
                        (this.state.current > 0)
                            ?
                            <button type="submit" className="btn btn-default color2" onClick={() => this.prev()}>
                                Previous
                            </button>
                            :
                            <button type="submit" className="btn btn-default color2" disabled style={{ visibility: "hidden" }}>
                                Previous
                            </button>

                    }
                    {/*Renders Next*/}
                    {
                        this.buttonHandler(steps)
                    }
                    {/*htmlType="submit" size="large"*/}
                    <center><a target="_blank" href='https://forms.nd.gov/231086668767875'>Contact: Technical Certification Program (TCP)</a>&emsp;&emsp;<a target="_blank" href='https://forms.nd.gov/231105789465866'>Contact: Erosion and Sediment Control (ESCC)</a></center>
                </div>
            </div>
        );
    }

    // Display button
    buttonHandler = (steps) => {
        if (this.state.current < steps.length - 1 && (this.state.filledMenuDisplay == true || this.state.current != 1 || this.state.currentMenu == 'No')) {
            return (<button className="btn btn-default" style={{ marginLeft: 10, float: 'right' }} onClick={() => this.next()}>Next</button>);
        }
        else if (this.state.current == 3) {
            return (<button className="btn btn-default" onClick={this.handleSubmit} style={{ float: 'right' }}>Register</button>);

        }
    }

    // Perform tasks when clicked next 
    next() {
        this.setState({ visible: false });
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const current = this.state.current + 1;
                if (this.state.current === 1 && values.dob != null) {
                    const student = this.state.student;
                    student.FirstName = this.capitalize(values.fname);
                    student.LastName = this.capitalize(values.lname);
                    student.MiddleInitial = values.mname;
                    student.DLN = values.dln;
                    student.StreetAddress = values.street;
                    student.State = values.state;
                    student.City = values.city;
                    student.ZipCode = values.zipcode;
                    student.PhoneNumber = values.phone;
                    student.Email = values.email;
                    student.DateofBirth = values.dob;
                    if (this.state.classData[0].ClassModeID == 3 && this.state.classData[0].ChosenAttendance == null) {
                        Modal.error({
                            title: 'No Attendence Selected',
                            content: "You have selected a hybrid class, which requires you to fill out the 'Attendance Selection' field.",
                        });
                        return;
                    }

                    this.setState({
                        student
                    });
                    this.setState({
                        current: current,
                    });
                    if (this.companydropdown !== '') {
                        this.setState({
                            inputControl: false
                        });
                    }
                }
                else {
                    if (this.state.classData[0].ClassModeID == 3 && this.state.classData[0].ChosenAttendance == null) {
                        Modal.error({
                            title: 'No Attendence Selected',
                            content: "You have selected a hybrid class, which requires you to fill out the 'Attendance Selection' field.",
                        });
                        return;
                    }
                    this.setState({ filledMenuDisplay: false, currentMenu: 'Yes', current: current });

                    if (this.state.current === 2) {
                        const employer = this.state.employer;
                        employer.CompanyName = values.company;
                        employer.Address = values.streetCompany;
                        employer.State = values.stateCompany;
                        employer.City = values.cityCompany;
                        employer.ZipCode = values.zipcodeCompany;
                        employer.PhoneNumber = values.phoneCompany;
                        employer.Email = values.emailCompany;
                        this.setState({
                            employer
                        });
                    }
                }
            }
        });
    }

    // Perform Tasks when clicked previous
    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
        if (current === 0) {
            this.setState({ filledMenuDisplay: false, currentMenu: 'Yes', selectedRowKeys: [], selectedRows: [], })
        }
        if (current === 1) {
            this.setState({ filledMenuDisplay: false, currentMenu: 'Yes', selectedRowKeys: [], selectedRows: [], existingButton: "Start New Registration" });
            this.state.student = {
                Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
                StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned', SComments: ''
            };
            this.state.employer = {
                Id: -1, CompanyName: '', Address: '', State: '',
                City: '', ZipCode: '', PhoneNumber: '', Email: ''
            };
            this.register = { student: this.state.student, employer: this.state.employer };
        }
    }

    // First page class search
    searchClass = () => {
        this.setState({
            searchClassData: this.props.form.getFieldValue("search")
        });

    }
    searchClassReset = () => {
        this.props.form.setFieldsValue({
            ['search']: '',
        });
        this.setState({
            searchClassData: ''
        });

    }

    /**
    * First Page - Select classes
    */
    firstPage = () => {
        const { getFieldDecorator } = this.props.form;
        /*------------------------------------------ Register for some Classes! ------------------------------------------*/
        return (
            <div className='forms'>
                {this.state.initialModal && <Modal
                    visible={true}
                    title={"Which system are you looking to use?"}
                    onCancel={() => this.setState({ initialModal: false })}
                    footer={<div></div>}
                    backdrop="static"
                >
                    <div style={{ textAlign: 'center' }}>
                        <button style={{ backgroundColor: '#0e406a', color: 'white', margin: '10px' }} className="btn btn-default" key="back" size="large" onClick={() => this.setState({ initialModal: false, filterSystem: "TCP", optionList: [<Option value="TCP">TCP</Option>, <Option value="ESCC">ESCC</Option>] })}>
                            TCP
                        </button>
                        <button style={{ backgroundColor: '#cf4520', color: 'white' }} className="btn btn-default" key="submit" type="primary" size="large" onClick={() => this.setState({ initialModal: false, filterSystem: "ESCC", optionList: [<Option value="ESCC">ESCC</Option>, <Option value="TCP">TCP</Option>] })}>
                            ESCC
                        </button>
                        <button style={{ backgroundColor: '#0e406a', color: 'white', margin: '10px' }} className="btn btn-default" key="submit" type="primary" size="large" onClick={() => this.setState({ initialModal: false, filterSystem: "External Civil Rights Training", optionList: [<Option value="External Civil Rights Training">External Civil Rights Training</Option>] })}>
                            Civil Rights
                        </button>
                    </div>
                </Modal>}
                {!this.state.initialModal && <div><FormItem
                    label="Certification System"
                    {...formItemLayout}>
                    {getFieldDecorator('system', {
                        initialValue: this.state.filterSystem
                    })(
                        <Select
                            placeholder="Select a system to register for."
                            onChange={this.handleSelectChangeSystem}>
                            {this.state.optionList}
                        </Select>
                    )}
                </FormItem>
                    <FormItem>
                        <RegisterClasses systemFilter={this.state.filterSystem} getData={this.setSelectedData} renderData={this.state.classDataKeys} searchName={this.state.searchClassData} multiStudent={false} />
                    </FormItem>
                    <p style={{ color: 'red' }}>If you have selected Hybrid courses please select how you would like to attend</p>
                    <Table rowKey="Id" columns={this.columnsSelect()} dataSource={this.state.classData} size="small" bordered />
                    <br /></div>}

            </div>
        );
    }

    /**
    * Second transition handler
    */
    secondPage = () => {
        const { getFieldDecorator } = this.props.form;
        /*------------------------------------------ User Login Page ------------------------------------------*/
        return (
            <div>
                {this.getMenuData()}
            </div>
        );
    }
    // Handles existing user selection
    onContinue = () => {
        this.setState({ visibleWarning: false });
        if (this.state.selectedRows.length == 1) {
            this.existingUser = { TechID: this.state.selectedRows[0].TechID, LastName: this.state.selectedRows[0].LastName };
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/registration/searchtech`,
                data: this.existingUser
            })
                .done((data) => {
                    this.existingUserData = data;
                    this.setState({
                        student: data.student,
                        employer: data.employer,
                        currentMenu: "No"
                    });

                    this.setState({
                        userVisible: false,
                        filledMenuDisplay: true
                    });

                    this.companydropdown = this.existingUserData.employer.CompanyName + ", " + this.existingUserData.employer.City + " (" + this.existingUserData.employer.State + ")";
                    this.userButtton = "Wrong Info!";


                })
                .fail((jqXhr) => {
                    console.log("Failed to search");
                });
        }

        else {
            this.setState({
                currentMenu: "No"
            });
        }
    }

    /**
        * Display menu for existing/new user
        */
    getMenuData() {
        if (this.state.currentMenu === 'Yes') {
            const { getFieldDecorator } = this.props.form;
            const { selectedRowKeys, selectedRows } = this.state;
            const rowSelection = {
                selectedRowKeys,
                selectedRows,
                onChange: this.onSelectChange,
            };
            const columnWarning = [
                {
                    title: 'First Name',
                    dataIndex: 'FirstName',
                },
                {
                    title: 'Middle I',
                    dataIndex: 'MiddleInitial',
                },
                {
                    title: 'Last Name',
                    dataIndex: 'LastName',
                },
                {
                    title: 'Employer',
                    dataIndex: 'CompanyName',
                    render: (text, record, index) => {
                        let emp = 'Not Available';
                        if (record.CompanyName) {
                            emp = record.CompanyName + ", " + record.EmployerCity + " (" + record.EmployerState + ")"
                        }
                        return (
                            <div>{emp}</div>
                        );
                    },
                },

            ];
            if (this.state.filledMenuDisplay === false) {
                return (
                    <div>

                        <Modal
                            visible={this.state.userVisible}
                            title={this.existingUserName}
                            onOk={this.handleUserYes}
                            onCancel={this.handleUserCancel}
                            footer={[
                                <button className="btn btn-default" key="back" size="large" onClick={this.handleUserCancel}>No</button>,
                                <button className="btn btn-default" key="submit" type="primary" size="large" onClick={this.handleUserYes}>
                                    Yes
                                </button>,
                            ]}
                        >
                        </Modal>
                        <div>
                            <br />
                            <br />
                            <Card style={{ width: 1150 }}>
                                <Row gutter={8}>
                                    <Col span={15} style={{ 'textAlign': 'center', }} >
                                        <FormItem  {...formItemLayout} label="Enter First or Last Name*">
                                            {getFieldDecorator('lNameEx')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={6} style={{ 'textAlign': 'center', }} >
                                        <button style={{ 'color': 'black', margin: 'auto', display: 'block' }} className="btn btn-default" onClick={() => this.validateExisting()}>Search</button>

                                    </Col>
                                </Row>
                            </Card>
                            <br />
                            {this.state.visibleWarning ? (
                                <div>
                                    If you see your name in the table select that row. You can edit details of your record on the next screen. <br />
                                    Don't see your name? Select "Start New Registration" below.
                                    <br />
                                    <br />
                                    <Table rowKey="StudentId" rowSelection={rowSelection} columns={columnWarning} dataSource={this.state.tableWarning} size="small" bordered />

                                    <br />
                                    <button style={{ 'color': 'black', margin: 'auto', display: 'block' }} className="btn btn-default" onClick={() => this.onContinue()}>{this.state.existingButton}</button>
                                </div>
                            ) : <div></div>}
                        </div>

                    </div>
                );
            }
            if (this.state.filledMenuDisplay === true) {
                return (this.getUserData());
            }
        }
        else {
            return (this.getUserData());
        }
    }

    //This is the student registration form. If its a new user these fields are blank.
    //If there's a preexisting user, the fields are populated with their information.
    getUserData = () => {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className='forms'>
                {/*------------------------------------------ User Details ------------------------------------------*/}
                <FormItem {...formItemLayout} label="First Name" >
                    {getFieldDecorator('fname', {
                        initialValue: this.state.student.FirstName,
                        rules: [{
                            required: true, message: 'Please input your first name!',
                        }],
                    })(<Input />)}
                </FormItem>
                {/*TODO: Limit one character*/}
                <FormItem {...shortFormItemLayout} label="Middle Initial" >
                    {getFieldDecorator('mname', {
                        initialValue: this.state.student.MiddleInitial,
                        rules: [{
                            required: false, message: 'Please input your middle initial!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label="Last Name" >
                    {getFieldDecorator('lname', {
                        initialValue: this.state.student.LastName,
                        rules: [{
                            required: true, message: 'Please input your last name!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem
                    {...formItemLayout} label="Date of Birth">
                    {getFieldDecorator('dob', {
                        initialValue: this.state.student.DateofBirth,
                        rules: [{
                            required: true, message: 'Please enter your date of birth!',
                        }],
                    })(

                        <DatePickerDropdown hideYear={true} isUserNew={this.state.isUserNew} getDOBNew={this.getDateOfBirthNew} sendUserData={this.state.student.DateofBirth} />
                    )}
                </FormItem>
                {/*------------------------------------------ ADDRESS ------------------------------------------*/}
                <FormItem style={{ display: 'none' }} {...formItemLayout} label="Street">
                    {getFieldDecorator('street', {
                        initialValue: this.state.student.StreetAddress,
                        rules: [{
                            required: false, message: 'Please input street!',
                        }],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label="City" >
                    {getFieldDecorator('city', {
                        initialValue: this.state.student.City,
                        rules: [{
                            required: true, message: 'City',
                        }],
                    })(<Input />)}
                </FormItem>

                <FormItem {...formItemLayout} label="State">
                    {getFieldDecorator('state', {
                        initialValue: this.state.student.State,
                        rules: [
                            { required: true, message: 'Please select your country!' },
                        ],
                    })(
                        <Select
                            showSearch
                            style={{ width: '40%' }}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.stateList}
                        </Select>)}
                </FormItem>

                <FormItem style={{ display: 'none' }} {...midFormItemLayout} label="Zip Code">
                    {getFieldDecorator('zipcode', {
                        initialValue: this.state.student.ZipCode,
                        rules: [{ required: false, message: 'Please input your zip code!' },
                        {
                            validator: this.checkZipCode,
                        }
                        ],
                    })(
                        <Input style={{ width: '100%' }} />
                    )}
                </FormItem>
                {/*------------------------------------------ CONTACT ------------------------------------------*/}
                <FormItem {...formItemLayout} label="Phone Number">
                    {getFieldDecorator('phone', {
                        initialValue: this.state.student.PhoneNumber,
                        rules: [{ required: true, message: 'Please input your phone number!' },
                        {
                            validator: this.checkZipPhone,
                        }],
                    })(
                        <Input style={{ width: '100%' }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout} label="Email">
                    {getFieldDecorator('email', {
                        initialValue: this.state.student.Email,
                        rules: [{
                            type: this.state.emailValidatorInfo, message: 'The input is not a valid e-mail!'
                        }, {
                            required: true, message: 'Please input your email!',
                        }, {
                            validator: this.checkConfirm,
                        }],
                    })(
                        <Input onBlur={this.handleEmailValidation} />
                    )}
                </FormItem>
            </div>
        );
    }
    /**
     * Second page method that runs on search button click
     */
    validateExisting = () => {
        var LastNameEx = this.capitalize(this.props.form.getFieldValue('lNameEx'));
        if (LastNameEx) {
            this.existingUser = { LastName: LastNameEx };
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/registration/searchtech`,
                data: this.existingUser
            })
                .done((data) => {
                    // previous pop up box functionality removed since techId was always -1 meant it never popped up
                    this.setState({
                        visibleWarning: true,
                        tableWarning: data
                    });
                })
                .fail((jqXhr) => {
                    console.log("Failed to search");
                });
        }
        else {
            Modal.error({
                title: 'Error message',
                content: 'Last name is required',
            });

        }

    }
    handleUserYes = () => {
        if (this.existingUserData) {
            this.setState({
                student: this.existingUserData.student,
                employer: this.existingUserData.employer
            });

            this.setState({
                userVisible: false,
                filledMenuDisplay: true
            });
            this.companydropdown = this.existingUserData.employer.CompanyName;
            this.userButtton = "Wrong Info!"
        }

        this.setState({
            userVisible: false,
            currentMenu: "No"
        });


    }
    handleUserCancel = () => {
        this.setState({ userVisible: false });
    }
    //Second page table button controller
    //Changes the button to submit or start new registraton
    onSelectChange = (selectedRowKeys, selectedRows) => {

        if (selectedRows.length == 1) {
            console.log("here");
            this.setState({
                selectedRowKeys: selectedRowKeys,
                selectedRows: selectedRows,
                existingButton: "Submit",
                isUserNew: false
            });
        }
        else if (selectedRows.length < 1) {
            this.setState({
                selectedRowKeys: selectedRowKeys,
                selectedRows: selectedRows,
                existingButton: "Start New Registration",
            });
        }
        else {
            Modal.error({
                title: 'Error',
                content: 'Only one student can be selected.',
            });

        }

    };


    handleEmailValidationUser = (e) => {
        this.setState({
            emailValidatorUser: 'email',
        },
            () => {
                this.props.form.validateFields(['emailEx'], { force: true });
            });

    }

    getDateOfBirth = (date) => {

        this.props.form.setFieldsValue({
            ['DOBEx']: date,
        });
        this.DobUser = date;
    }
    /**
    * Personal Data Entry form
    */
    getDateOfBirthNew = (date) => {

        this.props.form.setFieldsValue({
            ['dob']: date,
        });

    }


    handleEmailValidation = (e) => {
        this.setState({
            emailValidatorInfo: 'email',
        },
            () => {
                this.props.form.validateFields(['email'], { force: true });
            });

    }

    check = () => {
        this.props.form.validateFields(
            (err) => {
                if (!err) {
                    console.info('success');
                }
            },
        );
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }

    checkZipCode = (rule, value, callback) => {
        const form = this.props.form;
        if (/^\d{5}(-\d{4})?$/.test(value) || !value) {
            callback();
        }
        else
            callback('The value is not valid postal code');
    }

    checkZipPhone = (rule, value, callback) => {
        const form = this.props.form;
        if (/^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(value) || value === '') {
            callback();
        }
        else
            callback('Enter 10 digit phone number!');
    }

    checkEmail = (rule, value, callback) => {
        const form = this.props.form;
        if (this.state.current === 1) {
            if (value && value !== form.getFieldValue('email')) {
                callback('The two email addresses that you entered are inconsistent!');
            } else {
                callback();
            }

        }
        if (this.state.current === 2) {
            if (value && value !== form.getFieldValue('emailCompany')) {
                callback('The two email addresses that you entered are inconsistent!');
            } else {
                callback();
            }

        }


    }
    checkConfirm = (rule, value, callback) => {
        const form = this.props.form;
        if (this.state.current === 1) {
            if (value && this.state.confirmDirty) {
                form.validateFields(['emailConfirm'], { force: true });
            }
            callback();
        }
        if (this.state.current === 2) {
            if (value && this.state.confirmDirty) {
                form.validateFields(['emailConfirmCompany'], { force: true });
            }
            callback();
        }

    }

    resetData = (e) => {
        this.props.form.resetFields();
        this.existingUserData = '';
        this.setState({
            employer: {
                Id: -1, CompanyName: '', Address: '', State: 'ND',
                City: '', ZipCode: '', PhoneNumber: '', Email: ''
            },
            student: {
                Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
                StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned', SComments: ''
            },
            filledMenuDisplay: false,
            currentMenu: 'Yes'
        });
    }



    // Employer Info - The employee data entry page.

    thirdPage = () => {

        //If admin is logged in, make employer fields editable.
        if (Admin.isAdminLoggedIn()) {
            this.state.hideTextbox = false;
        }
        else {
            if (this.companydropdown == 403 || this.companydropdown == "Employer Not Listed, N/A (ND)") {
                this.state.employerNotList = true;
            }
            else {
                this.state.employerNotList = false;
            }
        }
        if (this.companydropdown == 403 || this.companydropdown == "Employer Not Listed, N/A (ND)") {
            if (this.state.classData[0].SystemName == "TCP") {
                this.state.employer.Email = "staylor@nd.gov";
            }
            else if (this.state.classData[0].SystemName == "ESCC") {
                this.state.employer.Email = "msperry@nd.gov";
            }
            else if (this.state.classData[0].SystemName == "External Civil Rights Training") {
                this.state.employer.Email = "civilrights@nd.gov";
            }
        }

        const { getFieldDecorator } = this.props.form;
        return (
            <div className='forms'>

                <FormItem
                    {...formItemLayout}
                    label="Select Employer from the List"
                >
                    <Select
                        showSearch
                        defaultValue={this.companydropdown}
                        style={{ width: '100%' }}
                        searchPlaceholder="Enter Company Name"
                        optionFilterProp="children"
                        onChange={this.handleChangeEmployer}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        {this.employerDisplayList}

                    </Select>
                </FormItem>

                {/*If user selected Employer not available, tell user to use contact forms*/}
                {this.handleNoEmployer()}

                {/*Company Name*/}
                <FormItem {...formItemLayout} label="Company Name" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('company', {
                        initialValue: this.state.employer.CompanyName
                    })
                        (<Input disabled={this.state.hideTextbox} />)
                    }
                </FormItem>

                {/*Street*/}
                <FormItem {...formItemLayout} label="Street" style={{ display: this.state.employerNotList ? 'none' : 'block' }} >
                    {getFieldDecorator('streetCompany', {
                        initialValue: this.state.employer.Address
                    })(<Input disabled={this.state.hideTextbox} />)}
                </FormItem>

                {/*City*/}
                <FormItem {...formItemLayout} label="City" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('cityCompany', {
                        initialValue: this.state.employer.City
                    })(<Input disabled={this.state.hideTextbox} />)}
                </FormItem>

                {/*State*/}

                <FormItem {...formItemLayout} label="State" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('stateCompany', {
                        initialValue: this.state.employer.State
                    })(
                        <Select
                            disabled={this.state.hideTextbox}
                            showSearch
                            style={{ width: '40%' }}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {this.stateList}
                        </Select>)}
                </FormItem>

                {/*Zipcode*/}

                <FormItem {...midFormItemLayout} label="Zip Code" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('zipcodeCompany', {
                        initialValue: this.state.employer.ZipCode
                    })(
                        <Input style={{ width: '100%' }} disabled={this.state.hideTextbox} />
                    )}
                </FormItem>

                {/*Phone number*/}

                <FormItem {...formItemLayout} label="Phone Number" style={{ display: this.state.employerNotList ? 'none' : 'block' }}>
                    {getFieldDecorator('phoneCompany', {
                        initialValue: this.state.employer.PhoneNumber
                    })(
                        <Input style={{ width: '100%' }} disabled={this.state.hideTextbox} />
                    )}
                </FormItem>

                {/*Email*/}

                <FormItem {...formItemLayout} label="Employer E-mail" >
                    {getFieldDecorator('emailCompany', {
                        initialValue: this.state.employer.Email
                    })(
                        <Input disabled={this.state.hideTextbox} onBlur={this.handleEmailValidationEmployer} />
                    )}
                </FormItem>
            </div>
        );
    }

    handleEmailValidationEmployer = (e) => {
        this.setState({
            emailValidatorEmployer: 'email',
        },
            () => {
                this.props.form.validateFields(['emailCompany'], { force: true });
            });
    }

    handleChangeEmployer = (value) => {
        this.props.form.resetFields();
        this.companydropdown = value;
        for (let i = 0; i < this.employerList.length; i++) {
            if (this.employerList[i].Id == value) {
                this.setState({
                    employer: this.employerList[i]
                });

                this.setState({
                    inputControl: false
                });
                break;
            }
            else {
                this.setState({
                    employer: {
                        Id: -1, CompanyName: 'Employer Not Available', Address: 'n/a', State: 'n/a',
                        City: 'n/a', ZipCode: 'n/a', PhoneNumber: 'n/a', Email: 'n/a'
                    }
                });
            }

        }
        this.setState({
            inputControl: false
        });

    }

    //If user doesn't have an employer available, they need
    //to request their employer be added before continuing
    //registration.
    handleNoEmployer = () => {
        if (this.companydropdown == 403) {
            return (
                <div>
                    <p id="employerMsg"
                        style={{ textAlign: 'center', color: 'red' }}>
                        * If your employer is not listed, please let us know by using one of the contact links below.
                    </p>
                </div>
            );
        }
    }

    //Functions used to display verification model

    adminFourth = () => {
        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <span><strong>{this.state.student.FirstName} {this.state.student.MiddleInitial} {this.state.student.LastName}</strong></span>

                    <br /> Email: {this.state.student.Email}
                    <br /> Company Name: {this.state.employer.CompanyName}
                    <br /> Tech ID: {this.state.student.TechID}
                    <br />
                    <br />
                    <br />
                    <Table rowKey="Id" columns={this.columnsSelect()} dataSource={this.state.classData} size="small" bordered />
                    <div id="emailDropdown">
                        Email*:
                        <br />
                        <Select
                            style={{ width: '450px' }}
                            value={this.state.emailValue}
                            onChange={this.handleEmailSelectChangeSystem}>
                            <Option value="Both">Send Email To Both Student And Employer</Option>
                            <Option value="Employer">Send Email To Employer</Option>
                            <Option value="Student">Send Email To Student</Option>
                            <Option value="None">Do Not Send Email</Option>
                        </Select>
                    </div>
                    <br />
                    <br />
                </Spin>
            </div>
        )
    }

    fourthPage = () => {
        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <span><strong>{this.state.student.FirstName} {this.state.student.MiddleInitial} {this.state.student.LastName}</strong></span>

                    <br /> Email: {this.state.student.Email}
                    <br /> Company Name: {this.state.employer.CompanyName}
                    <br /> Tech ID: {this.state.student.TechID}
                    <br />
                    <br />
                    <br />
                    <Table rowKey="Id" columns={this.columnsSelect()} dataSource={this.state.classData} size="small" bordered />
                    <br />
                    <br />
                </Spin>
            </div>)
    };


    //Used to assign the type of system using
    handleSelectChangeSystem = (value) => {
        this.setState({ filterSystem: value, initialModal: false });
    }

    handleEmailSelectChangeSystem = (value) => {
        this.setState({ emailValue: value });
    }
    //Gets the selected class list
    setSelectedData = (value, keys) => {
        this.setState({
            classData: value,
            classDataKeys: keys
        });
    }
    /**
     * helper in handle submit. 
     * @returns preexisting registrations
     */
    checkAndRemovePreexistingClassRegistrations = (data) => {

        var resultExt = this.state.classData; // updates to exlude preexisting registrations
        var resultDel = this.state.classData; // maintain all class, used to check found
        var alreadyRegistered = []; // id, name objects for pre-exist registrations
        var datakeyExt = []; // all ids of reusltExt

        for (var i in data) {
            // resultExt will be all classData where ID !== data[i]
            resultExt = resultExt.filter((classItem) => { return classItem.Id !== data[i]; });
            // resultDel is class data but some will check if calssitem id is data[i] id
            var found = resultDel.some((classItem) => {
                return classItem.Id === data[i];
            });
            // add to arr the id and class name that student is registered for
            if (found) {
                alreadyRegistered.push({ 'Id': resultDel[i].Id, 'Name': resultDel[i].Name });
            }
        }
        for (var i in resultExt) {
            datakeyExt.push(resultExt[i].Id);
        }
        // new class data for ones not already registered
        this.setState({
            classData: resultExt,
            classDataKeys: datakeyExt
        });

        return alreadyRegistered;
    }
    /**
    * Final submit handler
    */
    handleSubmit = (e) => {
        e.preventDefault();

        // this is the basic validation requiring attendance to be selected
        var errors = [];
        this.state.classData.forEach((classInfo) => {
            // for hybrid courses, if no attendance selected -> BAD
            if (classInfo.ClassModeID === 3) {
                if (!classInfo.ChosenAttendance) {
                    // do some error handling?
                    errors.push(`Class "${classInfo.Name}"`);
                }
            }
        });
        if (errors.length > 0) {
            //notify
            Modal.error({
                title: 'Class Data Invalid',
                content: "Please select attendance for all hybrid courses on page one. " +
                    errors.toString() + " did not have selected attendance.",
            });
            // openNotificationWithIcon("error", "Class Data Invalid", "Please select attendance for all hybrid courses on page one. " + 
            //     errors.toString() + " did not have selected attendance.");
            // console.error("Invalid selection for classmode")
        } else {
            this.register = { student: this.state.student, employer: this.state.employer, classData: this.state.classData, sendEmail: this.state.emailValue };
            //console.log(this.register);
            if (this.state.classData.length != 0) {
                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/students/existingclass`,
                    data: this.register
                })
                    .done((data) => { // data will be array of ints and they will be classId or -1 if not existing class

                        var alreadyRegistered = this.checkAndRemovePreexistingClassRegistrations(data); // returns [{ID, name}] of classes 

                        // I think this could be alreadyRegistered.length but will leave so it doesnt break
                        if (Object.keys(alreadyRegistered).length !== 0) {
                            const modal3 = Modal.info({
                                title: "Already registered for these class",
                                content: (<div><p>You are already registered for these classes</p>
                                    <Table rowKey="Id" columns={columnsExtClass} dataSource={alreadyRegistered} size="small" bordered />
                                    <p>To register for classes you haven't press register again</p>
                                </div>)
                                ,
                                onOk() { },
                            });

                        } else { // all new registrations please proceed

                            this.setState({
                                loading: true
                            });

                            $.ajax({
                                type: 'POST',
                                url: `${config.serverUrl}/api/registration/add`,
                                data: this.register
                            })
                                .done((data) => {
                                    //console.log(data);
                                    const modal = Modal.success({
                                        title: "Class registration successful!",
                                        content: 'Email with more information will be sent to you.',
                                        onOk() {
                                        }
                                    });

                                    this.setState({
                                        loading: false,
                                        current: 0
                                    });
                                })
                                .fail((jqXhr) => {
                                    console.log('failed to register');
                                    this.setState({
                                        loading: false
                                    });
                                    const modal2 = Modal.error({
                                        title: "Registration failed!",
                                        content: 'Server Error',
                                    });
                                });
                        }
                    })
                    .fail((jqXhr) => {
                        console.log('failed to register');
                    });
            } else {
                const modal1 = Modal.error({
                    title: "Class registration failed!",
                    content: 'Select a class to register',
                });
            }
        }

    }

    capitalize(str) {
        if (str)
            return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });

    }
}

const WrappedRegistrationForm = Form.create()(RegistrationForm);

export default WrappedRegistrationForm;




// WEBPACK FOOTER //
// ./src/Registration/RegistrationForm.js